import { useQuery } from "@tanstack/react-query";
import { INotification } from "Data/interfaces/Notification/INotification";
import { NOTIFICATIONS_TEMPORARY_QUERY_KEY } from "Data/keys/QueryKeys";

export const useQueryTemporaryNotifications = (
  constructionSiteId: number | null,
  personalKey: 'NOTIFICATIONS_PERSONAL_KEY' | null,
) => {
  const { data } = useQuery({
    queryKey: (constructionSiteId || personalKey)
      ? [NOTIFICATIONS_TEMPORARY_QUERY_KEY, (constructionSiteId ? Number(constructionSiteId) : personalKey)]
      : [NOTIFICATIONS_TEMPORARY_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      return [] as INotification[];
    },
  });

  return { data: data ?? [] };
};
